/**
 * QuickAction — static helpers for HTMX quick action buttons.
 *
 * Called from hx-on: attributes generated by cms.admin.quickActionButton().
 *
 * Usage in HTML:
 *   hx-on:htmx:after:request="QuickAction.reload()"
 *   hx-on:htmx:after:request="QuickAction.redirect('/admin/collections')"
 *   hx-on:htmx:error="QuickAction.error(this, event)"
 */
export default class QuickAction {

	static reload() {
		window.location.reload();
	}

	static redirect(url) {
		window.location.href = url;
	}

	static error(el, event) {
		console.error('Quick action failed:', event.detail);
		el.style.color = 'oklch(var(--totalform-error))';
	}
}
